import { gql } from '@grandvisionhq/graphql';
import { cartFailures, cartValidationErrors } from '../fragments/cart-validation-errors.js';

const GET_CART_ESTIMATED_DELIVERY = gql`
  query GetCartEstimatedDelivery($cartId: ID!) {
    cart(id: $cartId) {
      validationErrors {
        ...CartValidationErrorsFragment
      }
      failures {
        ...CartFailuresFragment
      }
      cart {
        id
        expectedDeliveryEstimation {
          ... on DateEstimation {
            deliveryDate
            shippingDate
          }
          ... on RangeEstimation {
            deliveryRange {
              min
              max
            }
          }
        }
      }
    }
  }
  ${cartFailures}
  ${cartValidationErrors}
`;

export { GET_CART_ESTIMATED_DELIVERY };
//# sourceMappingURL=get-cart-estimated-delivery.js.map
